<template>
  <v-container fluid class="pa-6">
    <div class="d-flex justify-space-between align-center mb-1">
      <div>
        <h1 class="font-weight-bold" style="font-size: 2em;">Gerenciar atendimentos</h1>
        <div class="subtitle-2" style="color: #666;">Acompanhe todas os atendimentos entre fisioterapeutas e pacientes</div>
      </div>
    </div>
    <v-row class="mb-6" dense>
      <v-col cols="12" md="3">
        <v-card class="pa-4" outlined>
          <div class="d-flex align-center">
            <div>
              <div class="caption mb-1">Agendados</div>
              <div class="font-weight-bold" style="font-size: 2em; color: #1976d2;">
                {{ relatorio.atendimentos_agendado }}
              </div>
            </div>
            <v-spacer></v-spacer>
            <v-icon color="blue" size="32">mdi-calendar</v-icon>
          </div>
        </v-card>
      </v-col>
      <v-col cols="12" md="3">
        <v-card class="pa-4" outlined>
          <div class="d-flex align-center">
            <div>
              <div class="caption mb-1">Concluídos</div>
              <div class="font-weight-bold" style="font-size: 2em; color: #43a047;">
                {{ relatorio.atendimentos_concluidos }}
              </div>
            </div>
            <v-spacer></v-spacer>
            <v-icon color="green" size="32">mdi-account</v-icon>
          </div>
        </v-card>
      </v-col>
      <v-col cols="12" md="3">
        <v-card class="pa-4" outlined>
          <div class="d-flex align-center">
            <div>
              <div class="caption mb-1">Cancelados</div>
              <div class="font-weight-bold" style="font-size: 2em; color: #e53935;">
                {{ relatorio.atendimentos_cancelado }}
              </div>
            </div>
            <v-spacer></v-spacer>
            <v-icon color="red" size="32">mdi-phone-off</v-icon>
          </div>
        </v-card>
      </v-col>
    </v-row>
    <v-card class="pa-4" outlined>
      <div class="font-weight-bold mb-3" style="font-size: 1.2em;">Lista de atendimentos</div>
      <v-row class="mb-4">
        <v-col cols="12" md="3">
          <v-select 
            :items="statusOptions" 
            label="Todos os Status" 
            dense 
            outlined 
            v-model="filtroStatus"
            @change="pegarAtendimentos">
          </v-select>
        </v-col>
        <v-col cols="12" md="4">
          <v-text-field v-model="filtroNome" prepend-inner-icon="mdi-magnify" placeholder="Buscar por paciente ou fisioterapeuta..." dense outlined @keyup.enter="pegarAtendimentos"></v-text-field>
        </v-col>
      </v-row>
      <v-simple-table>
        <thead>
          <tr>
            <th>Paciente</th>
            <th>Fisioterapeuta</th>
            <th>Data/Hora</th>
            <th>Especialidade</th>
            <th>Status</th>
            <th>Ações</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="atendimentos.length === 0">
            <td colspan="9" class="text-center grey--text">
              Nenhum atendimento encontrado
            </td>
          </tr>
          <tr v-for="(item, i) in atendimentos" :key="i">
            <td>
              {{ item.paciente && item.paciente.pessoa ? item.paciente.pessoa.nome + ' ' + item.paciente.pessoa.sobrenome : '---' }}
            </td>
            <td>
              {{ item.fisioterapeuta && item.fisioterapeuta.pessoa ? item.fisioterapeuta.pessoa.nome + ' ' + item.fisioterapeuta.pessoa.sobrenome : '---' }}
            </td>
            <td>{{ formatarDataHora(item.data_hora) }}</td>
            <td>{{ item.especialidade.nome }}</td>
            <td>
              <v-chip :color="item.statusColor" dark small>{{ item.statusTexto }}</v-chip>
            </td>
            <td>
              <v-btn icon small @click="visualizar(item)">
                <v-icon color="primary">mdi-eye</v-icon>
              </v-btn>
            </td>
          </tr>
        </tbody>
      </v-simple-table>
    </v-card>
      <v-pagination class="mt-5"
        v-model="pagina"
        :length="totalPaginas"
        @input="pegarAtendimentos(false)"
        show-first-last-page
        show-page-numbers
        :total-visible="9"
       />
    <v-dialog v-model="dialogDetalhes" max-width="900">
      <DetalhesAtendimento
        v-if="atendimentoSelecionado"
        :atendimento="atendimentoSelecionado"
        @fechar="dialogDetalhes = false"
        @cancelar="cancelar(atendimentoSelecionado)"
      />
    </v-dialog>
  </v-container>
</template>

<script>
import DetalhesAtendimento from '@/components/dialogs/DetalhesAtendimento.vue'

const statusMap = {
  1: { texto: 'Não realizado', cor: 'grey' },
  2: { texto: 'Realizado', cor: 'green' },
  3: { texto: 'Cancelado', cor: 'red darken-2' },
  4: { texto: 'Aguardando Aprovação', cor: 'blue lighten-2' },
  5: { texto: 'Agendado', cor: 'black' },
  6: { texto: 'Reagendado', cor: 'orange' },
  7: { texto: 'Aprovado', cor: 'green darken-2' },
  8: { texto: 'Negado', cor: 'red' }
}
export default {
  name: 'GerenciarAtendimentos',
  components: {
    DetalhesAtendimento
  },
  data() {
    return {
      statusOptions: [
        { text: 'Todos os Status', value: null },
        { text: 'Não realizado', value: 1 },
        { text: 'Realizado', value: 2 },
        { text: 'Cancelado', value: 3 },
        { text: 'Aguardando Aprovação', value: 4 },
        { text: 'Agendado', value: 5 },
        { text: 'Reagendado', value: 6 },
        { text: 'Aprovado', value: 7 },
        { text: 'Negado', value: 8 }
      ],
      atendimentos: [],
      atendimentoSelecionado: null,
      filtroStatus: null,
      filtroNome: '',
      dialogDetalhes: false,
      relatorio:{atendimento_agendado:0, 
        atendimento_cancelado:0,
        atendimento_concluidos:0,
        total_atendimentos:0,
      },
      itensPorPagina: 5,
      pagina: 1,
      totalItens: 0,
    } 
  },
  created() {
    this.pegarAtendimentos()
    this.pegarRelatorio()
  },
  computed: {
    totalPaginas() {
      return Math.ceil(this.totalItens / this.itensPorPagina)
    },
    atendimentosPaginados() {
      const start = (this.pagina - 1) * this.itensPorPagina;
      const end = start + this.itensPorPagina;
      return this.atendimentos.slice(start, end);
    },
  },
  methods: {
    pegarAtendimentos(resetPage=true) {
      if (resetPage) this.pagina = 1
      const filtros = {
        page: this.pagina,
        page_size: this.itensPorPagina
      }
      
      if (this.filtroStatus) filtros.status = this.filtroStatus
      if (this.filtroNome) filtros.nome = this.filtroNome

      this.$store.dispatch('pegarAtendimentos', filtros)
        .then(data => {
          const lista = Array.isArray(data) ? data : data.results || []
          this.atendimentos = lista.map(atendimento => {
            const statusInfo = statusMap[atendimento.status] || { texto: 'Desconhecido', cor: 'grey' }
            return {
              ...atendimento,
              statusTexto: statusInfo.texto,
              statusColor: statusInfo.cor
            }
          })
          this.totalItens = data.count || this.atendimentos.length
        })
        .catch(err => {
          console.error(err)
        })
    },
    pegarRelatorio() {
      this.$store.dispatch('pegarRelatorios')
        .then(data => {
          this.relatorio = data
        })
        .catch(err => {
          console.error('Erro ao pegar relatório:', err)
        })
    },
    formatarDataHora(iso) {
      if (!iso) return ''
      const [data, hora] = iso.split('T')
      return `${data.split('-').reverse().join('/')} às ${hora.slice(0,5)}`
    },
    visualizar(item) {
      this.atendimentoSelecionado = item
      this.dialogDetalhes = true
    }
  }
}
</script>

<style scoped>
th, td {
  padding: 12px 8px !important;
}
.v-chip {
  font-weight: bold;
  font-size: 0.95em;
}
</style>